// providers
import { trans } from "@/_providers/Translation"

// images
import bgFlagImage from "@/assets/img/icons/bg-flag.svg"
import tkFlagImage from "@/assets/img/icons/tk-flag.svg"
import ukFlagImage from "@/assets/img/icons/uk-flag.svg"

export default function PhoneField({
  label,
  name,
  codeValue,
  numberValue,
  onCodeChange,
  onNumberChange,
  disabled,
  disabledCodeSelect,
  placeholder,
  codeName,
  numberName,
  props,
  validate,
}) {
  const COUNTRY_CODES = [
    { value: "+359", label: "+359", icon: bgFlagImage },
    { value: "+1", label: "+90", icon: tkFlagImage },
    { value: "+44", label: "+44", icon: ukFlagImage },
  ]

  return (
    <div className={`phone-field ${validate ? "validate" : ""}`}>
      <img
        src={COUNTRY_CODES.find((code) => code.value === codeValue)?.icon}
        alt="icon"
      />
      <select
        value={codeValue}
        onChange={onCodeChange}
        disabled={disabled || disabledCodeSelect}
        name={codeName}
      >
        {COUNTRY_CODES.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <input
        type="text"
        value={numberValue}
        onChange={onNumberChange}
        placeholder={placeholder}
        disabled={disabled}
        name={numberName}
      />
    </div>
  )
}
